// extracted by mini-css-extract-plugin
export default {"historyContainer":"History_historyContainer__CJn6l","historyTable":"History_historyTable__1c3zF"};